













































































































import { Vue } from "vue-property-decorator";
import { mapState, mapActions, mapGetters } from "vuex";
import AppLayout from "@/components/app-layout.vue";
import AppAdo from "@/components/app-ado.vue";
import { Pointage, SHOW_LOADING } from "@/store/types";
import BoutonList from "@/features/home/components/bouton-list.vue";
import { Etablissement } from "../../models/Etablissement";
import store from "@/store";

export default Vue.extend({
  // A modifier plus tard // Solution provisoire
  beforeRouteEnter(to, from, next) {
    store.dispatch("etablissements/fetchListEtablissements").then(function () {
      next();
    });
  },
  components: {
    AppLayout,
    AppAdo,
    BoutonList,
  },

  data() {
    return {
      items: [
        {
          icon: "XL_FICHES_INDIVIDUS",
          title: this.$t("anmobi.home.fiches_individus"),
          href: "ListIndividus",
        },
        {
          icon: "XL_POINTAGES",
          title: this.$t("anmobi.home.pointages"),
          href: "activites",
        },
        {
          icon: "XL_PARAMETRES",
          title: this.$t("anmobi.home.parametres"),
          href: "parametres",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("etablissements", [
      "getCurrentEtablissement",
      "getlistEtablissement",
    ]),
  },
  methods: {
    replaceByDefault(event: any) {
      event.target.src = require(`@/assets/inoe-logo/Logo_iNoe.svg`);
    },
  },
});
